import { Select } from '@insights-ltd/design-library/components';
import { SelectProps, SelectTypes } from '../SearchFilter.types';

export const LeftSelect = <T extends SelectTypes['leftSelectOptionsType']>({
  value,
  onChange,
  options,
}: SelectProps<T>) => {
  return (
    <Select
      id="left-select"
      inputProps={{ 'data-testid': 'left-select-input' }}
      aria-label="left filter selector"
      value={value}
      onChange={(event) => onChange(event.target.value as T)}
      items={Object.fromEntries(
        options.map(({ label, value: optionValue }) => [optionValue, label]),
      )}
      fullWidth
      sx={{ marginRight: '1rem', width: '19%' }}
    />
  );
};
